<script setup lang="ts">
import { useHashTab } from "@/vf/components/hash-tab/useHashTab"
import { computed, onMounted, ref } from "vue"
import VarsityFeedbackLoading from "../feedback/VarsityFeedbackLoading.vue"

const props = defineProps<{ tab: string; onlyHide?: boolean; preload?: boolean }>()
const { activeTab } = useHashTab()!

const preloaded = ref(false)
const isActive = computed(() => activeTab.value === props.tab)
const shouldRender = computed(() => isActive.value || (props.preload && preloaded.value))

onMounted(() => {
    if (!props.preload) return
    if ("requestIdleCallback" in window) {
        requestIdleCallback(() => {
            preloaded.value = true
        })
    } else {
        setTimeout(() => {
            preloaded.value = true
        }, 200)
    }
})
</script>

<template>
    <div v-if="shouldRender" v-show="isActive">
        <Suspense :key="tab">
            <template #default>
                <slot></slot>
            </template>
            <template #fallback><VarsityFeedbackLoading class="my-5" /></template>
        </Suspense>
    </div>
</template>
